import React from 'react'
import { Text } from './text'
import './checkbox.css'

/**
 * CheckBox
 */
export const CheckBox = (props) => {

    const { id, label, placeholder, value, onChange } = props

    function change(event) {
        event.stopPropagation()
        event.preventDefault()
        const value = event.target.checked
        if (onChange) onChange(id, value)
    }

    const labelTxt = <Text>{label}</Text>
    
    return value === true  ? (
        <div className="checkbox" key={`${id}1`}>
            <input id={id} type="checkbox" placeholder={placeholder} checked value={value} onChange={change} />
            <span className="checkmark" />
            <label htmlFor={id}>{labelTxt}</label>
        </div>
    ) : (
        <div className="checkbox" key={`${id}0`}>
        <input id={id} type="checkbox" placeholder={placeholder} value={value} onChange={change} />
        <span className="checkmark" />
        <label htmlFor={id}>{labelTxt}</label>
    </div>
    )
}